module.exports = "https://cdn-challenge.mathletics.com/app/281/assets/fonts/652970624cde999882102fa2b6a8871f.woff2";